import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'membership_new_members'

export const useMembershipsNewMembersReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'New members',
    headerTooltipTitle: 'New members',
    headerTooltipDescription: 'Number of new member subscriptions.',
  })
}
